
<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div>
                        <h5>Notificaciones</h5>
                        <p>Para habilitar tus notificaciones, habilita y guárda desde aquí</p>
                    </div>
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 mb-2 border-right" v-for="(item, index) in states" :key="index">
                            <div class="row align-items-center">
                                <div class="col-lg-2">
                                    <div class="icon icon-shape rounded-3 bg-light text-dark text-lg me-4">
                                        <i class="bi bi-envelope"></i>
                                    </div>
                                </div>
                                <div class="col-lg-8 d-flex align-items-center">
                                    <h5>{{ item.name }}</h5>
                                </div>
                                <div class="col-lg-2 d-flex align-items-center">
                                    <v-switch v-model="item.notify" hide-details></v-switch>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-4">
                            <div class="form-group">
                                <button class="btn btn-success btn-sm" @click="SAVE()">Guardar cambios</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'user',
        ])
    },
    data () {
        return {
            states: [],
            count: 0
        }
    },
    created () {
        let vue = this
        vue.STATES()
    },
    methods: {
        STATES: function(){
            let vue = this
            axios({url: '/notify/states', method: 'GET' })
            .then((resp) => {
                vue.states = resp.data
            })
            .finally((resp) => {
                vue.MY_NOTIFICATIONS()
            })
        },
        MY_NOTIFICATIONS: function(){
            let vue = this
            axios({url: '/me/notifications', method: 'GET' })
            .then((resp) => {
                let data = resp.data
                vue.states.forEach(element => {
                    element.notify = data.find((e) => e.id == element.id).state
                });
                vue.states.map((e) => data.find((d) => d.id == e.id) ? e.notify == 1 : e.notify = 0)
            })
        },
        SAVE: function () {
            let vue = this
            vue.count++
            if(vue.count == 1){
                let notifications = vue.states.filter((item, index) => {
                    if(item.notify == 1){
                        return item
                    }
                }).map((item, index) => {
                    return item.id
                })
                setTimeout(() => {
                    axios({url: '/me/notifications', method: 'POST', data: { notifications: notifications} })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/profile/tabs/Notifications.vue